<template>
    <Layout>
        <div class="mc-liveview" :class="{ 'sidebar-collapsed': !sidebarOpen }">
            <div class="mc-liveview__map-area">
                <!-- Judul di atas map -->
                <div class="mc-map-header">
                    <h2 class="mc-map-header__title">Alamat Teknisi</h2>
                </div>
                <!-- Wrapper untuk map agar mengisi sisa ruang -->
                <div class="mc-map-wrapper">
                    <Map />
                </div>
            </div>
            <transition name="sidebar-slide">
                <div v-show="sidebarOpen" class="mc-liveview__sidebar-area">
                    <SideBar />
                </div>
            </transition>
        </div>
    </Layout>
</template>

<script>
import appConfig from '@/app.config'
import Layout from '@/router/layouts/main';
import Map from './Map.vue';
import SideBar from './SideBar.vue';

export default {
    name: 'TechnicianAddress',
    page: {
        title: 'Alamat Teknisi', // title untuk tab browser
        meta: [{ name: 'description', content: appConfig.description }],
    },
    components: { Layout, Map, SideBar },
    computed: {
        sidebarOpen() {
            return this.$store.state.sidebar.sideBarOpen;
        },
    },
    async created() {
        this.$store.commit('map/TYPE_OF_MAP', 'user');
        if (!this.$store.state.sidebar.sideBarOpen) {
            this.$store.commit('sidebar/toggleSideBar');
        }
        this.$store.dispatch('map/setCENTER', {
            zoom: 5.56,
            open: false,
            gmp: null,
            type: 'fleet',
        });
    },
};
</script>

<style scoped>
.mc-liveview {
    display: flex;
    height: calc(100vh - 110px);
    width: 100%;
    overflow: hidden;
    position: relative;
    background: #f5f7fa;
}

.mc-liveview__map-area {
    flex: 1 1 auto;
    min-width: 0;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
}

/* Header judul map */
.mc-map-header {
    flex-shrink: 0;
    padding: 12px 20px;
    background: #ffffff;
    border-bottom: 1px solid #e5e9f0;
}

.mc-map-header__title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
    color: #1e293b;
}

/* Wrapper map yang mengisi sisa ruang */
.mc-map-wrapper {
    flex: 1;
    min-height: 0;
    position: relative;
}

.mc-liveview__sidebar-area {
    flex: 0 0 400px;
    max-width: 400px;
    height: 100%;
    background: #ffffff;
    border-left: 1px solid #e5e9f0;
    box-shadow: -4px 0 16px rgba(15, 23, 42, 0.04);
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

@media (max-width: 768px) {
    .mc-liveview__sidebar-area {
        position: absolute;
        right: 0;
        z-index: 1050;
        width: 85%;
    }
}

.sidebar-slide-enter-active,
.sidebar-slide-leave-active {
    transition: transform 0.3s ease;
}

.sidebar-slide-enter,
.sidebar-slide-leave-to {
    transform: translateX(100%);
}
</style>
